import request from '@/config/axios'

export interface PriceVO {
  id: string | number
  shopId: string | number
  spuId: string | number
  skuId?: string | number
  date: string
  price: number
  extraBedPrice: number
}

export interface BatchSetDTO {
  id?: string | number
  shopId: string | number
  spuId: string | number
  skuId?: string | number
  date: string
  price: number
  extraBedPrice: number
}

// 日历价格查询
export const queryCalendar = (params: any) => {
  return request.get({ url: '/hotel/price/list-by-date-range', params })
}

// 批量设置价格
export const batchSet = (data: BatchSetDTO[]) => {
  return request.post({ url: '/hotel/price/batch-set', data })
}

// 获取单条价格
export const getPrice = (id: string | number) => {
  return request.get({ url: '/hotel/price/get?id=' + id })
}
